import { createBrowserRouter, Navigate, RouterProvider } from 'react-router'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/app.scss'
import { Paths } from 'types/paths'
import Auth from 'pages/Auth/Auth.tsx'
import {
  ARCHIVED_EMAILS,
  CONTRACT_CONSUMPTIONS,
  EVENTLOG,
  CONTRACTS,
  CREATE_INTERNAL_USER,
  CREATE_SALES_EVENT,
  CREATE_SALES_PARAMETER,
  CREATE_SALES_USER,
  CREDIT_CHECKS,
  DATA_DASHBOARD,
  EDIT_INTERNAL_USER,
  EDIT_SALES_EVENT,
  EDIT_SALES_PARAMETER,
  EDIT_SALES_USER,
  FEEDBACK_WIDGETS,
  FEEDBACK_WIDGETS_DETAIL,
  GOALS_DASHBOARD,
  INTERNAL_USERS,
  LOGIN,
  MONTHLY_VOLUMES,
  PASSWORD_RESET,
  PRODUCER,
  PRODUCERS,
  SALES_BULK_CSV_UPLOAD,
  SALES_EVENTS,
  SALES_PARAMETERS,
  SALES_USERS,
  USERS
} from 'router/routes.tsx'
import ErrorElement from 'router/ErrorElement.tsx'

/**
 * Creates the routes.
 * Loads all routes "lazy" except the Login route.
 */
const routes = createBrowserRouter([
  {
    path: Paths.HOME,
    errorElement: <ErrorElement />,
    children: [
      {
        // PROTECTED ROUTE
        async lazy() {
          const ProtectedRoute = await import('components/ProtectedRoute/ProtectedRoute')
          return { Component: ProtectedRoute.default }
        },
        children: [
          {
            // APP
            async lazy() {
              const App = await import('pages/AppContainer/AppContainer.tsx')
              return { Component: App.default }
            },
            children: [
              { index: true, element: <Navigate to={Paths.DATA_DASHBOARD} replace /> },
              DATA_DASHBOARD,
              GOALS_DASHBOARD,
              PRODUCERS,
              PRODUCER,
              CONTRACTS,
              CONTRACT_CONSUMPTIONS,
              MONTHLY_VOLUMES,
              FEEDBACK_WIDGETS,
              FEEDBACK_WIDGETS_DETAIL,
              CREDIT_CHECKS,
              USERS,
              PASSWORD_RESET,
              INTERNAL_USERS,
              EDIT_INTERNAL_USER,
              CREATE_INTERNAL_USER,
              SALES_BULK_CSV_UPLOAD,
              SALES_EVENTS,
              CREATE_SALES_EVENT,
              EDIT_SALES_EVENT,
              SALES_PARAMETERS,
              CREATE_SALES_PARAMETER,
              EDIT_SALES_PARAMETER,
              SALES_USERS,
              CREATE_SALES_USER,
              EDIT_SALES_USER,
              ARCHIVED_EMAILS,
              EVENTLOG
            ]
          }
        ]
      },

      /* AUTHENTICATION */
      { element: <Auth />, children: [LOGIN] }
    ]
  },
  /* Catch all */
  { path: '*', element: <Navigate to={Paths.LOGIN} replace /> }
])

const Router = () => {
  return <RouterProvider router={routes} />
}

export default Router
